(ns dre.pages.search.views.widgets-menu
  (:require
   [dre.components.icon :refer [icon fa-icon]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.i18n.views :refer [tr]]
   [dre.utils.bem :as bem]
   [dre.widgets.db]
   [dre.widgets.events :as-alias widgets]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name :widgets-menu)

(defn- child-view
  [widget {:keys [title] :as child}]
  [:div
   {:class (bem/be component-name :child)
    :on-click #(rf/dispatch [::widgets/toggle-active
                             (:id widget)
                             {:child-option child}])}
   title])

(defn- children-view
  [widget children]
  [:div
   {:class (bem/be component-name :children)}
   (->> children
        (map-indexed (fn [i child]
                       ^{:key i}
                       [child-view widget child])))])

(defn- entry-view
  [_]
  (let [collapsed? (r/atom true)]
    (fn [{:keys [idx entry active? dashboard-menu-expanded?]}]
      (let [{:keys [id title used-in-search-sub tooltip children]} entry
            is-used? (and used-in-search-sub @(rf/subscribe [used-in-search-sub]))]
        [:<>
         [tooltip-wrapper (str title (when tooltip " - ") tooltip)
          [:li
           {:class (bem/bem component-name :item (when (active? id) :active))
            :on-click #(rf/dispatch [::widgets/toggle-active id])}
           [icon :widgets id]
           [:span
            {:class (bem/be component-name :item-label)}
            [tr title]]
           (when (and
                  @dashboard-menu-expanded?
                  (seq children))
             [:div
              {:class (bem/be component-name :chevron)
               :on-click #(do
                            (.preventDefault %)
                            (.stopPropagation %)
                            (swap! collapsed? not))}
              (if @collapsed? (icoinor-icon :nav-arrow-down) (icoinor-icon :nav-arrow-up))])
           [:div
            {:class (bem/bem component-name :highlight-dot (when is-used? :active))}]] {:placement "right"}]
         (when (and
                @dashboard-menu-expanded?
                (seq children)
                (not @collapsed?))
           [children-view entry children])]))))

(defn view
  []
  (let [dashboard-menu-expanded? (r/atom false)]
    (fn []
      (let [active? @(rf/subscribe [::widgets/active])
            icon-size {:width "1em" :height "1em"}]
        [:ul
         {:class (bem/bm component-name (when @dashboard-menu-expanded? :expanded))}
         ^{:key "expand-button"}
         [:li
          {:class (bem/bem component-name :expand-button nil)}
          [tooltip-wrapper (if @dashboard-menu-expanded?
                             "Collapse Dashboard menu"
                             "Expand Dashboard menu")
           [:span
            {:on-click #(swap! dashboard-menu-expanded? not)}
            (if @dashboard-menu-expanded?
              (icoinor-icon :nav-arrow-left icon-size)
              (icoinor-icon :nav-arrow-right icon-size))]
           {:placement "right"}]]
         ^{:key "menu-icon"}
         [tooltip-wrapper "Select and un-select widgets to be displayed in your dashboard, then use the widget data to filter your search results for relevancy."
          [:li
           {:class (bem/bem component-name :header-icon nil)}
           [icon :widgets :menu]]
          {:placement "right"}]
         ^{:key "menu-label"}
         [tooltip-wrapper "Select and un-select widgets to be displayed in your dashboard, then use the widget data to filter your search results for relevancy."
          [:li
           {:class (bem/bem component-name :header-label nil)}
           [:span.content
            [tr "Dashboard Menu"]]]
          {:placement "right"}]
         (doall
          (for [[idx entry] (map-indexed vector (dre.widgets.db/registry))]
            [entry-view {:idx idx
                         :entry entry
                         :active? active?
                         :dashboard-menu-expanded? dashboard-menu-expanded?}]))]))))